import { httpsCallable } from 'firebase/functions';
import { functions } from 'services/Firebase';

type Request = {
  projectId: string;
  totalRevenue: number;
  month: string;
  mode: 'processAndReport' | 'processAndReportForce' | 'reportOnly';
};

type Response = {
  csvReport: string;
};

export const splitSubscriptionsRevenueByPlayTime = httpsCallable<Request, Response>(
  functions,
  'splitSubscriptionsRevenueByPlayTime',
);
